<template>
  <div class="home">
    <NavbarMain />
    <div class="container py-5">
      <CarouselHome />
      <PaymentInfo />
      <CurrenciesCarousel />

      <div class="products my-5">
        <h3>
          <span>Algunos productos</span>
        </h3>
        <hr />
        <div class="row" style="position: relative">
          <FakeProduct
            v-show="!products.length"
            v-for="fp in fakeProducts"
            :key="fp + Math.random()"
            class="col-xl-3 col-md-6 pt-4"
          />
          <Product
            v-for="product in products"
            :key="product._id"
            class="col-xl-3 col-md-4 pt-4"
            :product="product"
            :kind="'products'"
          />
        </div>
      </div>

      <div>
        <img
          src="https://api.treidblue.com/public/images/slider/banner5.gif"
          class="d-block w-100"
        />
      </div>
      <div class="products my-5">
        <h3>
          <span>Más productos para vos</span>
        </h3>
        <hr />
        <div class="row" style="position: relative">
          <FakeProduct
            v-show="!productsRandom.length"
            v-for="fp in fakeProducts.slice(0, 4)"
            :key="fp + Math.random()"
            class="col-xl-3 col-md-6 pt-4"
          />
          <Product
            v-for="product in productsRandom"
            :key="product._id"
            class="col-xl-3 col-md-4 pt-4"
            :product="product"
            :kind="'products'"
          />
        </div>
      </div>

      <CarouselSqueare3 />

      <div class="products my-5">
        <h3>Algunos servicios</h3>
        <hr />
        <div class="row">
          <FakeProduct
            v-show="!services.length"
            v-for="fp in fakeProducts"
            :key="fp + Math.random()"
            class="col-xl-3 col-md-6 pt-4"
          />
          <Product
            v-for="service in services"
            :key="service._id"
            class="col-xl-3 col-md-4 pt-4"
            :product="service"
            :kind="'services'"
          />
        </div>
      </div>

      <div>
        <img
          src="https://api.treidblue.com/public/images/slider/banner3.gif"
          class="d-block w-100"
        />
      </div>

      <div class="products my-5">
        <h3>
          <span>Más servicios para vos</span>
        </h3>
        <hr />
        <div class="row" style="position: relative">
          <Product
            v-for="product in servicesRandom"
            :key="product._id"
            class="col-xl-3 col-md-4 pt-4"
            :product="product"
            :kind="'services'"
          />
          <FakeProduct
            v-show="!servicesRandom.length"
            v-for="fp in fakeProducts.slice(0, 4)"
            :key="fp + Math.random()"
            class="col-xl-3 col-md-6 pt-4"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "../tools/Api2";
import Configs from "@/configs/configs";
import { mapState, mapMutations } from "vuex";
import Product from "@/components/Product.vue";
import NavbarMain from "@/components/NavbarMain.vue";
import PaymentInfo from "@/components/promotion/PaymentInfo.vue";
import CarouselHome from "@/components/promotion/CarouselHome.vue";
import CurrenciesCarousel from "@/components/CurrenciesCarousel.vue";
import CarouselSqueare3 from "@/components/promotion/CarouselSqueare-3.vue";
import FakeProduct from "@/components/FakeProduct.vue";

export default {
  name: "Home",
  data() {
    return {
      products: [],
      productsRandom: [],
      servicesRandom: [],
      services: [],
      url: Configs.API.BASE,
      fakeProducts: [1, 2, 3, 4, 5, 6, 7, 8],
    };
  },
  components: {
    NavbarMain,
    Product,
    CurrenciesCarousel,
    CarouselSqueare3,
    CarouselHome,
    PaymentInfo,
    FakeProduct,
  },
  created: async function () {
    if (this.counters.products) {
      // Get Product
      this.getProductRandom().then((products) => {
        this.products = products;
      });

      // Get service
      this.getServiceRandom().then((services) => {
        this.services = services;
      });

      // Get Product
      this.getProductRandom(4).then((products) => {
        this.productsRandom = products;
      });

      // Get service
      this.getServiceRandom(4).then((service) => {
        this.servicesRandom = service;
      });
    } else {
      this.getCount().then(() => {
        // Get Product
        this.getProductRandom().then((products) => {
          this.products = products;
        });

        // Get service
        this.getServiceRandom().then((service) => {
          this.services = service;
        });

        // Get Product
        this.getProductRandom(4).then((products) => {
          this.productsRandom = products;
        });

        // Get service
        this.getServiceRandom(4).then((services) => {
          this.servicesRandom = services;
        });
      });
    }
  },
  computed: {
    ...mapState(["counters", "flag"]),
  },
  methods: {
    ...mapMutations(["setCounters"]),
    getProductRandom(n = 8) {
      const skip = Math.abs(
        Math.floor(Math.random() * this.counters.products) - n
      );
      return Api(
        `product?limit=8&filter[state]=1&filter[sellerPlaces]=${this.flag}&skip=${skip}`
      ).get().then( res => res.products.slice(0,n));
    },
    getServiceRandom(n = 8) {
      const skip = Math.abs(
        Math.floor(Math.random() * this.counters.services) - n
      );
      return Api(
        `service?limit=8&filter[state]=1&filter[sellerPlaces]=${this.flag}&skip=${skip}`
      ).get().then( res => res.services.slice(0,n));
    },
    getCount() {
      return Api("count")
        .get(`products?filter[state]=1&filter[sellerPlaces]=${this.flag}`)
        .then((products) =>
          Api("count")
            .get(`services?filter[state]=1&filter[sellerPlaces]=${this.flag}`)
            .then((services) => this.setCounters({ products, services }))
        );
    },
  },
};
</script>

<style lang="css" scoped>
.home {
  height: 100%;
}
</style>
